import type { InvoiceFormData } from "@/services/invoiceUploadService";
import type { Participant } from "@/types/expense";

export function classifyVendorAccountInput(raw: string): NonNullable<InvoiceFormData["vendorAccountFields"]> {
  const trimmed = raw.trim();
  if (!trimmed) return {};
  if (/^[A-Z]{2}\d/.test(trimmed)) return { vendor_iban: trimmed };
  if (/^\d{4,5}-\d{4}$/.test(trimmed)) return { vendor_bankgiro: trimmed };
  if (/^\d[\d\s]*-\d$/.test(trimmed)) return { vendor_plusgiro: trimmed };
  return { vendor_bankgiro: trimmed };
}

interface SharedSubmitSource {
  vendorAccountInput?: string;
  sourceAccountId?: string;
  bankBic?: string;
  bankName?: string;
  paymentMethod?: InvoiceFormData["paymentMethod"];
  expenseCategory?: string;
  participants?: Participant[];
}

/**
 * The fields the upload form's draft path (PDF/image) and manual-entry path send identically.
 * Kept in one place because each path used to list them by hand, and one of them silently
 * lacked `sourceAccountId` (FIN-962).
 */
export function sharedSubmitFields(data: SharedSubmitSource) {
  return {
    vendorAccountFields: data.vendorAccountInput ? classifyVendorAccountInput(data.vendorAccountInput) : undefined,
    sourceAccountId: data.sourceAccountId,
    bankBic: data.bankBic,
    bankName: data.bankName,
    paymentMethod: data.paymentMethod,
    expenseCategory: data.expenseCategory,
    categoryMetadata: data.participants && data.participants.length > 0
      ? { participants: data.participants }
      : {},
  };
}
